import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Controller, useForm } from 'react-hook-form';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import CustomFormSelect from "components/select/CustomFormSelect";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
import { deleteFileManagerById, getFileManagersById } from "components/axios/fileManagerAxios";
import FileDownloadIcon from "components/FileDownloadIcon";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { extensionCheck, fileAccepts, ROLE } from 'data/data';
import { useEnumApi } from "contexts/EnumApiContext";
import { customFileAxios } from "components/axios/customAxios";
import { getEquipmentCtgr1ByZone } from "components/axios/equipmentAxios";
import usePermission from "hooks/usePermission";
import { PERMISSIONS } from "config/permissions";
import PermissionButton from "components/PermissionButton";
import PermissionLoadingButton from "components/PermissionLoadingButton";

const DataModifySetting = () => {
    const { getEnumValueByEnumName, loginInfo } = useEnumApi();
    const { t, i18n } = useTranslation();

    const selectOptions = useMemo(() => {
        return fileAccepts.map(item => ({
            code: item.code,
            title: t(item.titleKey),
            extension: item.extension,
        }));
    }, [t, i18n.language]); // 언어 변경 시 자동 재계산

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const {id} = useParams();
    const { control, register, handleSubmit, formState : {isDirty, errors } } = useForm({});

    const [equipmentCategory1s, setEquipmentCategory1s] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState(0);
    const [file, setFile] = useState(null);
    const [fileId, setFileId] = useState(null);
    const [accept, setAccept] = useState({});
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);

    const { hasPermission } = usePermission();
    const canWrite  = hasPermission(PERMISSIONS.SETTING_DATAROOM_WRITE);
    // console.log(loginInfo)
    const isOwner = loginInfo.role === ROLE.SA.code || data?.createdBy === loginInfo.id;
    const canModify = canWrite && isOwner;

    useEffect(()=> {
        getEquipmentCtgr1ByZone().then((data)=>{
            setEquipmentCategory1s(data)
        })
    }, [])

    useEffect(() => {
        if(!isLoading && id) {
            getFileManagersById(id).then((data)=>{
                setData(data);
                return data;
            }).then((res2)=>{
                setEquipmentCategoryLevel1Id(res2 && res2.equipmentCtgr && res2.equipmentCtgr.parent && (res2.equipmentCtgr.parent.id ||''));
                if (res2.attachedFiles && res2.attachedFiles.length > 0) {
                    const extension = res2.attachedFiles[0].originFile.substring(res2.attachedFiles[0].originFile.lastIndexOf("."));
                    const accept = fileAccepts.filter(item => item.extension.indexOf(extension.toLowerCase()) !== -1);
                    // console.log(accept)
                    setAccept(accept[0]);
                    setFileId(res2.attachedFiles[0].id);
                }
                setIsLoading(true);
            })
        }
    },[isLoading, id]);

    // 설비중분류 목록
    useEffect(()=>{
        // console.log(equipmentCategoryLevel1Id)
        if (isLoading && equipmentCategoryLevel1Id) {
            const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
            if (data && data._embedded) {
                const list = data._embedded.equipmentCategories;
                if (list) {
                    setEquipmentCategoryLevel2s(list);
                } else {
                    setEquipmentCategoryLevel2s([]);
                }
            } else {
                setEquipmentCategoryLevel2s([]);
            }
        });
    }
    },[isLoading, equipmentCategoryLevel1Id]);

    // 파일삭제
    function deleteFile() {
        setFileId(null);
    }

    // 수정
    let onSubmit = (data) => {
        setFileLoading(true);

        const equipmentCategoryLevel1Id = data.equipmentCategoryLevel1Id;
        const equipmentCategoryLevel2Id = data.equipmentCategoryLevel2Id;
        const fileType                  = data.fileType;
        const fileAccept                = data.fileAccept;
        const title                     = data.title;

        if (file) {
            if (!extensionCheck(file.name, fileAccept)) {
                handleAlertClick(t('message.common.alert.file.not.match.type'));
                setFileLoading(false);
                return;
            }
        } else {
            if (fileId === null) {
                handleAlertClick(t('message.common.alert.file.select'));
                setFileLoading(false);
                return;
            }
        }
        
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                let dto = {
                    id : id,
                    equipmentCtgr : {
                        id : equipmentCategoryLevel2Id,
                        parent : {id : equipmentCategoryLevel1Id}
                    },
                    title,
                    fileType
                };

                if (!file && (fileId && fileId !== 0)) {
                    dto.attachedFiles = [{id : fileId}];
                }

                let formData = new FormData();
                formData.append("files", file);
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

                for (var value1 of formData.entries()) {
                    console.log(value1[0]+', ',value1[1]);
                }
                try {
                    const res = customFileAxios.patch(`/api/fileManagers/${id}`, formData).then((res)=>{
                        console.log(res);
                        handleAlertClick(t('message.common.alert.modify.done'));
                        setFileLoading(false);
                        setIsLoading(false);
                    }).catch((err)=>{
                        console.log(err);
                        handleAlertClick(err.response?.data?.message || err.message);
                    });
                    // return res.data;
                } catch (error) {
                    console.error("error :", error);
                    throw error;
                }
                
                // axios({
                //     method: "patch",
                //     url: window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/fileManagers/"+id,
                //     data: formData,
                //     headers : {
                //         'Content-type' : 'multipart/form-data',
                //         accept : 'application/json,',
                //         'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
                //         'Accept-Language' : t('locale')
                //     }
                // }).then((res)=>{
                //     console.log(res);
                //     handleAlertClick(t('message.common.alert.modify.done'));
                //     setFileLoading(false);
                //     setIsLoading(false);
                // }).catch((err)=>{
                //     console.log(err);
                //     handleAlertClick(err.response?.data?.message || err.message);
                // });
            },
            onClose : () => {
              //  console.log('close');
              setFileLoading(false);
            },
            message: t('message.common.alert.modify.question'),
        });    
    };

    const handleDeleteBtnClick = (param) => {
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            deleteFileManagerById(param).then((res) => {
              document.location.href = '/setting/data/dataroom'+window.location.search;
            }).catch((err)=>{
              console.log(err);
              handleAlertClick(err.response?.data?.message || err.message);
            });
          },
          onClose : () => {
            console.log('close');
          },
          message: t('message.common.alert.delete.question'),
          });
      }

    if (isLoading && data) {
        return (
    <div>
      {/* <div className="mro_search">
        <h5 className="mro_m_left">* {t('menu.cmms.management.data')}</h5>
      </div> */}

      <form onSubmit={handleSubmit(onSubmit)}>
        <TableContainer>
          <Table sx={{ minWidth: 1000 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}} >
            <TableBody>
              <TableRow key={0}>
                <TableCell className="th" style={{height:"70px"}}>{t('message.common.subtitle.equipment.level1')}</TableCell>
                <TableCell className="email_pl">
                    {equipmentCategory1s && <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel1Id ? "true" : "false"}
                        control={control}
                        name="equipmentCategoryLevel1Id"
                        render={({ field: {name} }) => (
                        <CustomFormSelect
                            key={"equipmentCategoryLevel1Id"}
                            style={{ minWidth: '90%' }}
                            label={t('message.common.subtitle.equipment.level1')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.level1.select')}
                            defaultValue={(data && data.equipmentCtgr && data.equipmentCtgr.parent && (data.equipmentCtgr.parent.id ||''))}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel1Id(e.target.value);
                            }}
                            list={equipmentCategory1s}
                        />
                        )}
                    />}
                    {errors.equipmentCategoryLevel1Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel1Id.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                <TableCell className="email_pl">
                    {equipmentCategoryLevel2s && 
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel2Id ? "true" : "false"}
                        control={control}
                        name="equipmentCategoryLevel2Id"
                        render={({ field: {name} }) => (
                        <CustomFormSelect
                            key={"equipmentCategoryLevel2Id"}
                            style={{ minWidth: '90%' }}
                            label={t('message.common.subtitle.equipment.level2')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.level2.select')}
                            defaultValue={(data && data.equipmentCtgr && (data.equipmentCtgr.id ||''))}
                            list={equipmentCategoryLevel2s}
                        />
                        )}
                    />
                    }
                    {errors.equipmentCategoryLevel2Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel2Id.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.select.division')}</TableCell>
                <TableCell className="email_pl">
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.fileType ? "true" : "false"}
                        control={control}
                        name="fileType"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            key={"fileType"}
                            style={{ minWidth: '90%' }}
                            label={t('message.common.select.division')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.division.select')}
                            defaultValue={(data && (data.fileType ||''))}
                            list={getEnumValueByEnumName("FileType")}
                        />
                        )}
                    />
                    {errors.fileType && <small role="alert"><br></br>{errors.fileType.message}</small>}
                </TableCell>
              </TableRow>
              <TableRow key={1}>
                <TableCell className="th" style={{height:"70px"}}>{t('message.common.subtitle.title')}</TableCell>
                <TableCell colSpan={3} className="email_pl">
                    <TextField 
                        aria-invalid={!isDirty ? undefined : errors.title ? "true" : "false"}
                        {...register("title", {
                            required : t('message.common.error.text.title.input')
                        })} 
                        defaultValue={(data && (data.title ||''))}
                        sx={{ m: 1, minWidth: '90%'}}
                    />
                    {errors.title && <small role="alert"><br></br>{errors.title.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.type2')}</TableCell>
                <TableCell className="email_pl">
                    <Controller
                        sx={{ m: 1, minWidth: "90%" }}
                        aria-invalid={!isDirty ? undefined : errors.fileAccept ? "true" : "false"}
                        control={control}
                        name="fileAccept"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            key={"fileAccept"}
                            style={{ minWidth: '90%' }}
                            label={t('message.common.subtitle.type2')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.type2.select')}
                            defaultValue={data && accept && (accept.code || '')}
                            onChange={(e)=>{
                                let accept = fileAccepts.filter(item => item.code === e.target.value);
                                setAccept(accept[0]);
                            }}
                            list={selectOptions}
                        />
                        )}
                    />
                    <br></br>{accept?.extension}
                    {errors.fileAccept && <small role="alert"><br></br>{errors.fileAccept.message}</small>}
                </TableCell>
              </TableRow>
              <TableRow key={2}>
                <TableCell className="th" style={{height:"70px"}}>{t('message.common.subtitle.file')}</TableCell>
                <TableCell colSpan={5} className="email_pl">
                    <div style={{display:"flex"}}>
                        <input
                            type="file" 
                            accept={accept?.extension}
                            onChange={(e)=>{setFile(e.target.files[0]);setFileId(null);}}
                        />
                        {data && data.attachedFiles && fileId &&
                            <>
                                <FileDownloadIcon file={data.attachedFiles[0]} viewFileName={true} fontColor="#000" />
                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteFile()}>-</RemoveCircleOutlineIcon>
                            </>
                        }
                    </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </form>

      <div style={{marginTop:"10px", display:"flex", justifyContent:"space-between"}}>
        <div><Link to={'/setting/data/dataroom'+window.location.search}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.list')}</Button></Link></div>
        <div>
        {/* {data == null && <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>} */}
        {canModify && 
            <PermissionLoadingButton
                permission={PERMISSIONS.SETTING_DATAROOM_MODIFY_DELETE}
                variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}
            >
                {t('message.common.btn.modify')}
            </PermissionLoadingButton>
            // <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>
        }
        {canModify && <>&nbsp;&nbsp;
            <PermissionButton
                permission={PERMISSIONS.SETTING_DATAROOM_MODIFY_DELETE}
                variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(id)}}
            >
                {t('message.common.btn.delete')}
            </PermissionButton>
            {/* <Button variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(id)}}>{t('message.common.btn.delete')}</Button> */}
        </>}
        </div>
      </div>
    </div>
        )
    }
}

export default DataModifySetting;